module.exports = __webpack_public_path__ + "img/gongzhonghao.b4925eb8.png";